<template>
<div>
    <div class="breadcrumbs" id="breadcrumbs">
        <span class="breadcrumb-link">Preferences</span> &gt;
        <router-link class="breadcrumb-link" to="/settings/team-members">Team Members</router-link>
    </div>
    <h3>Team Members</h3>
      <div class="large-form">
        <div class="form-line">
            <h4 style="margin-top: 0">Current Team Members</h4>

            <div class="form-line-fields">
                <div class="form-field">
                    <label>Current Team Members</label>
                    <table class="worksends-table inset team-members">
                        <thead>
                        <tr>
                            <th>Team Member</th>
                            <th>Status</th>
                            <th>Role</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="member in team.managers" v-if="!['bb_spectator'].includes(member.role)">
                            <td class="field-name" data-label="Team Member" style="min-width: 230px;"><div class="value"><b>{{ member.name }}</b><br />{{ member.email }}</div></td>
                            <td class="field-status" data-label="Status" :data-status="member.status"><div class="value">{{ member.status }}</div></td>
                            <td class="field-role" data-label="Role" :data-role="member.role"><div class="value">{{ fullRoleName(member.role) }}</div></td>
                            <td class="field-actions" data-label="Actions"><div class="value">
                                <div v-if="member.role !== 'bb_admin'" @click="openUserEditModal(member.user_id)" class="ws-button small">Edit</div>
                                <div v-if="member.role !== 'bb_admin'" @click="deleteTeamMember(member.user_id)" class="ws-button ws-button-negative small">Remove</div>
                            </div></td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <div class="form-line-desc"><br />
              <p><b>Team Managers</b> always have full access to the team's Bookblock HUB platform</p>
              <p><b>Team Associates</b> can be assigned various access to different components of Bookblock HUB in the permission section of the team member edit screen.</p>
              <p><i><b>BB HUB Account Manager</b></i> is your team's Bookblock HUB account manager.</p>
            </div>
        </div>
        <div class="form-line">
            <h4>Add New Team Member</h4>
            <p>To add a new team member, please enter their email and choose their role.<br />We will send them a sign-up email to join your team.</p>

            <div class="form-line-fields">
                <div class="form-field" style="width: 65%">
                    <input v-model="teamMemberInput.email" type="text" id="form-input-invite-email" placeholder="Email"/>
                </div>

                <div  class="form-field" style="width: 35%">
                    <select v-model="teamMemberInput.role">
                        <option value="">-- Role --</option>
                        <option value="manager">Team Manager</option>
                        <option value="associate">Team Associate</option>
                    </select>
                </div>

                <div class="form-field" style="width: 100%; margin-top: 10px;">
                    <div @click="inviteManager" class="ws-button" href="#">Invite To Team</div>
                </div>

            </div>

            <div class="form-line-desc">
                <div class="small-note error" >
                    <div v-for="e in teamMemberInput.errors" class="error-text">{{ e[0] }}</div>
                </div>
            </div>

        </div>
    </div>
    <payment-method-modal v-if="modals.paymentMethodModal" @added="modals.paymentMethodModal = false"></payment-method-modal>
    <user-settings-modal v-if="modals.userSettings" :team-member-id="editUserId" @updated="onTeamMemberUpdate"></user-settings-modal>

</div>
</template>

<script>
import UserSettingsModal from '@/pages/settings/UserSettingsModal';

export default {
    name: "SettingsTeamMembers",
    components: {UserSettingsModal},
    data() {
        return {
            teamMemberInput: {email:'', role:'', errors:[]},
            domainInput: {domain:'', errors:[]},
            userErrors: {},
            paymentMethodsLoaded: false,
            editUserId: null,
        }
    },
    methods: {
        async inviteManager() {
            if (!this.demoCheck()) return;
            if (!this.proCheck('Adding, editing or removing team members')) return;

            this.teamMemberInput.errors = this.validateFields([
                { name: 'Email', value: this.teamMemberInput.email, rules: ['required', 'email', 'minLength:6'] },
                { name: 'Role', value: this.teamMemberInput.role, rules: ['required'] },
            ]);

            if (Object.keys(this.teamMemberInput.errors).length) {
                return;
            }

            await this.dispatchWaitAndNotify('addTeamMember', { email: this.teamMemberInput.email, role: this.teamMemberInput.role, status: 'invited', send_email: true });
            this.teamMemberInput.email = "";
            this.teamMemberInput.role = "";
        },
        openUserEditModal(userId) {
            if (!this.demoCheck()) return;
            if (!this.proCheck('Adding, editing or removing team members')) return;

            this.editUserId = userId;
            this.modals.userSettings = true;
        },
        deleteTeamMember(userId) {
            if (!this.demoCheck()) return;
            if (!this.proCheck('Adding, editing or removing team members')) return;
            
            this.dispatchWaitAndNotify('deleteTeamMember', userId);
        },
        async onTeamMemberUpdate() {
            await this.dispatchWaitAndNotify('fetchTeam', null, false, true);
            this.modals.userSettings = false;
        },
        fullRoleName(name) {
            if (name=='manager') return 'Team Manager';
            else if (name=='associate') return 'Team Associate';
            else if (name=='bb_admin') return 'BB HUB Account Manager';
            else return name;
        },
    },
    mounted() {
        //this.fetchData();
    },
    computed: {
        team() {
            return this.$store.state.team.detail;
        },
        teamCopy() {
            return this.$store.state.team.detailCopy;
        },
        user() {
            return this.$store.state.currentUser;
        },
        emailCategories() {
            return this.$store.state.emailCategories;
        },
        modals() {
            return this.$store.state.modals;
        },
        stripePaymentMethods() {
            return this.$store.state.transaction.stripePaymentMethods;
        }
    }
}
</script>
